module.exports = __webpack_public_path__ + "static/media/banner-back.c73e7448.png";